import { lazy, Suspense } from 'react';

const withSuspense = (importFunc, fallback = null) => {
  const LazyComponent = lazy(importFunc);

  const WrappedComponent = (props) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = 'withSuspense';

  return WrappedComponent;
};

export default withSuspense;
